import { IProduct, ProductSearch } from 'src/app/models/products/product';

export function updateRecentlyList(list: IProduct[], data: ProductSearch): IProduct[] {
  if (!data.id) {
    return list;
  }
  const maxLength = list.length;
  const filtered = list.filter((x) => x.id !== data.id);
  return [data, ...filtered].slice(0, maxLength);
}
